export default defineNuxtPlugin(() => {
  const { $feature } = useNuxtApp()
  const {
    pages: { plp },
    components: { vf: { video, carousel, header, mediaGallery }, cms: { promoBar } }
  } = useAppConfig()

  if ($feature.tempVansNewNav.active && $feature.tempVansNewNav.value) {
    plp.brandClasses.breadcrumbs = 'lg:mt-9'
    video.brandClasses.control.wrapper = 'bottom-0 m-2 <lg:mr-4'
    carousel.brandClasses.progressControls = 'p-2 pt-2 flex right-0 absolute z-10 lg:p-6 bottom-0'

    promoBar.allowMixBlendMode = false
    header.floatingNavigation = false

    mediaGallery.brandClasses.carousel = 'gap-1 bg-white'
    mediaGallery.brandClasses.pagination = 'lg:hidden'
    mediaGallery.brandClasses.carouselItem = '<lg:!w-[95vw]'

    mediaGallery.showPagination = true
  }
})
